import { Routes } from '@angular/router';

export const mpsCoreRoutes: Routes = [];
